import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { CommonModalWindows } from '../components/CommonModalWindows/CommonModalWindows';
import { LoaderConfig } from '../components/LoaderConfig/LoaderConfig';
import { MainView } from '../components/MainView/MainView';
import { NotificationModal } from '../components/NotificationModal/NotificationModal';
import { SectionsParams } from '../components/SectionsParams/SectionsParams';
import { MenuMain } from '../components/StandartComponent/MainMenu/MainMenu';
import { WrapModals } from '../components/WrapModals/WrapModals';
import { CustomerInfo } from '../Sections/CustomerInfo/CustomerInfo';
//@ts-ignore
import { setAllSettingConfig, setMainStep } from '../store/actions/setting';
import { getIsLoadStateData } from '../store/selectors/selectors';
//@ts-ignore
import s from './MainPage.module.scss';

export const MainPage = () => {

    // const isLoadData: boolean = true;
    const dispatch = useDispatch();

    // Promise.all([initializationLogicApi()]).then(res => {
    //     console.log('res', res)
    // });


    // Promise.all([getConfigurableProducts()]).then((res) => {
    // })
    dispatch(setAllSettingConfig({ allSetting: [] }))


    const isLoadState: boolean = useSelector(getIsLoadStateData);
    return (
        <>
            {isLoadState && (
                <>

                    <div className={s.WrapPage}>
                        <div className={s.wrap}>
                            <MenuMain />
                        </div>
                        <div className={s.wrapSection}>
                            <SectionsParams />
                        </div>
                        <div className={s.mainView}>
                            <MainView />
                        </div>
                    </div >

                    <CustomerInfo funcNextStep={() => dispatch(setMainStep('Product'))} />

                    <CommonModalWindows />
                </>
            )}

            {!isLoadState && (<>
                <WrapModals>
                    <LoaderConfig />
                </WrapModals>
            </>)}
            <NotificationModal />

        </>
    )
}